import React, { Component } from "react";
import classes from "./AADT.module.css";
import AADTForm from "./AADTForm/AADTForm";
import SmallModal from "../../../hoc/UI/SmallModal/SmallModal";

class AADT extends Component {
  state = {
    aadt_id: null
  };

  componentDidMount() {
    this.props.aadt.fetch();
  }

  render() {
    let smallModal = null;
    if (this.props.showSmallModal) {
      smallModal = (
        <SmallModal>
          <AADTForm
            toggleSmallModalHandler={this.props.toggleSmallModalHandler}
            currentAADT={
              this.props.aadt.aadt.filter(
                item => item.project_aadt_id === this.state.aadt_id
              )[0]
            }
            update={this.props.aadt.update}
            projectID={this.props.currentProjectID}
            add={this.props.aadt.add}
          />
        </SmallModal>
      );
    }
    return (
      <div className={classes.AADT}>
        <button
          onClick={() => {
            this.setState({ aadt_id: null });
            this.props.toggleSmallModalHandler();
          }}
        >
          Create new AADT
        </button>
        {smallModal}

        <table>
          <thead>
            <tr>
              <th>Year</th>
              <th>Daily Traffic</th>
              <th>Notes</th>
            </tr>
          </thead>
          <tbody>
            {this.props.aadt.aadt.map(item => (
              <tr
                key={item.project_aadt_id}
                onClick={e => {
                  if (e.target.type !== "button") {
                    this.setState({
                      aadt_id: item.project_aadt_id
                    });
                    this.props.toggleSmallModalHandler();
                  }
                }}
              >
                <td>{item.year}</td>
                <td>{item.daily_traffic}</td>
                <td>{item.notes}</td>
                <td>
                  <button
                    type="button"
                    onClick={() =>
                      this.props.aadt.delete(
                        item.project_aadt_id,
                        this.props.currentProjectID
                      )
                    }
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default AADT;
